module.exports = __webpack_public_path__ + "static/media/TvShowBanner (1).56fbe28a.png";